import { Outlet, Link } from "react-router-dom";
const titleImage = require('./art/title.gif')


const Layout = () => {
  return (
    <div className = "container">
      <img alt="Tim's cool website" className='centerImage' style={{ width: "70%" }} src={String(titleImage)} />

      <Outlet />
    </div>
  )
};

export default Layout;
